import PagePointage from "@features/pointage/components/PagePointage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/pointage/$hash")({
  component: PagePointage,
});
